import React from 'react';
import classnames from 'classnames';
import { ListGroup, ListGroupItem, Panel } from 'react-bootstrap';
import FilterByCodeItem from './FilterByCodeItem.jsx';
import { useStateValue } from '../../context/state.jsx';

const FilterByCode = () => {
	const [{
		datasets,
		currentDataset,
		projectFilter,
		projectActivityCodesTree,
		projectActivityCodesTreeSequence,
		projectActivityCodesRelativesMap
	}] = useStateValue();

	const datasetInfo = currentDataset && datasets ? datasets[currentDataset] : null;
	if (!datasetInfo) {
		return null;
	}
	const { filterOptions } = datasetInfo;

	if (!Array.isArray(projectActivityCodesTreeSequence)) {
		return null;
	}
	const codeTree = [];
	for (let i = 0; i < projectActivityCodesTreeSequence.length; i++) {
		const t = projectActivityCodesTreeSequence[i];
		const codeItem = projectActivityCodesTree[t];
		codeTree.push(
			<ListGroupItem key={t} className="codeTreeTypeItem">
				<FilterByCodeItem
					codeItem={codeItem}
					filterOptions={filterOptions}
					projectFilter={projectFilter}
					projectActivityCodesRelativesMap={projectActivityCodesRelativesMap} />
			</ListGroupItem>
		);
	}

	let filterHasCodes = false;
	for (const i in projectFilter.activityCodes) {
		if (Object.keys(projectFilter.activityCodes[i]).length) {
			filterHasCodes = true;
			break;
		}
	}

	return (
		<Panel
			className={classnames('filterByCodeTree', { activeFilter: filterHasCodes })}>
			<Panel.Heading>
				<Panel.Title toggle>Codes</Panel.Title>
			</Panel.Heading>
			<Panel.Collapse>
				<ListGroup>
					{codeTree}
				</ListGroup>
			</Panel.Collapse>
		</Panel>
	);
};

export default FilterByCode;
